const ADD_SALES_ORDER = "ADD_SALES_ORDER";
const DELETE_SALES_ORDER = "DELETE_SALES_ORDER";
const SALES_ORDERS = "SALES_ORDERS";
const ADD_SALES_ORDER_ERROR = "ADD_SALES_ORDER_ERROR";
const SALES_ORDER_DETAILS = "SALES_ORDER_DETAILS";
const UPDATE_SALES_ORDER = "UPDATE_SALES_ORDER";
const SALES_ORDER_REPORTS = "SALES_ORDER_REPORTS";

export {
  ADD_SALES_ORDER,
  DELETE_SALES_ORDER,
  SALES_ORDERS,
  ADD_SALES_ORDER_ERROR,
  SALES_ORDER_DETAILS,
  UPDATE_SALES_ORDER,
  SALES_ORDER_REPORTS,
};
